import React from "react";

import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { X, Info } from "lucide-react";
import CurrencyFormatter from "../utils/currencyFormatter";
import withdrawIcon from "../assets/images/withdrawaIcon.svg";
import zarDeposit from "../assets/images/zarDeposit.svg";
import receiveIcon from "../assets/images/receiveIcon.svg";
import { FormattedDate } from "../utils/dateFormatter";

const InvestTransactionHistorySingle = ({
  selectedTransaction,
  openSingle,
  setOpenSingle,
  asset,
  onClose,
}) => {
  // const formatTransactionDate = (createdAt) => {
  //   const transactionDate = new Date(createdAt);

  //   const date = transactionDate.toLocaleDateString("en-ZA", {
  //     day: "2-digit",
  //     month: "short",
  //     year: "numeric",
  //   });

  //   const hours = transactionDate.getHours().toString().padStart(2, "0");
  //   const minutes = transactionDate.getMinutes().toString().padStart(2, "0");
  //   const seconds = transactionDate.getSeconds().toString().padStart(2, "0");

  //   const timezoneOffset = -transactionDate.getTimezoneOffset(); // in minutes
  //   const offsetHours = Math.floor(timezoneOffset / 60)
  //     .toString()
  //     .padStart(2, "0");
  //   const offsetSign = timezoneOffset >= 0 ? "+" : "-";

  //   const time = `${hours}:${minutes}:${seconds} (GMT${offsetSign}${offsetHours})`;

  //   return `${date}, ${time}`;
  // };

  const handleDialogChange = (open) => {
    setOpenSingle(open);
    if (!open) {
      onClose();
    }
  };
  const dateFormat = new FormattedDate();
  const simpleFormat = dateFormat.simpleFormat(selectedTransaction?.createdAt);
  const detailedFormat = dateFormat.detailedFormat(
    selectedTransaction?.createdAt
  );
  const formatter = new CurrencyFormatter();

  return (
    <Dialog open={openSingle} onOpenChange={handleDialogChange}>
      <DialogTrigger asChild></DialogTrigger>
      <DialogContent className="max-w-[780px] rounded-2xl p-6 flex-1 flex flex-col pb-12">
        <DialogClose asChild>
          <Button
            variant="ghost"
            onClick={() => setOpenSingle(false)}
            className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
          >
            <X size={18} className="text-gray-700" />
          </Button>
        </DialogClose>

        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-800">
            Transaction
          </DialogTitle>
          <div className="grid grid-cols-4 gap-4 grid-rows-1 mb-3">
            <div className="space-y-2 col-span-4">
              <div className="px-5 py-4 mx-5 rounded-2xl mt-4  bg-gray-50 flex items-center justify-between">
                <div className="flex items-center justify-center">
                  <div className="mr-3">
                    {selectedTransaction?.type === "withdrawal" ? (
                      <img src={withdrawIcon} alt="" />
                    ) : selectedTransaction?.type === "deposit" ? (
                      <img src={zarDeposit} alt="" />
                    ) : (
                      <img src={receiveIcon} alt="" />
                    )}
                  </div>
                  <div className="">
                    <p className="text-[16px] text-text-primary font-semibold">
                      {selectedTransaction?.type === "withdrawal"
                        ? "Withdraw"
                        : selectedTransaction?.type === "deposit"
                          ? "Deposit"
                          : "Payout"}
                    </p>
                    <p className="text-[14px] text-text-secondary font-normal">
                      {simpleFormat}
                    </p>
                  </div>
                </div>
                <div className="font-semibold">
                  {formatter.format(
                    selectedTransaction?.amount,
                    asset.toUpperCase()
                  )}
                </div>
              </div>
            </div>
          </div>
        </DialogHeader>
        {/* BuySell */}
        {selectedTransaction && (
          <div className="px-6 mt-6">
            <div className="border rounded-lg divide-y">
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Amount</span>
                <span className="text-sm font-bold text-gray-800">
                  {formatter.format(
                    selectedTransaction?.amount,
                    asset.toUpperCase()
                  )}
                </span>
              </div>
              {/* <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Status</span>
                <span className="text-sm font-bold text-gray-800">
                  {selectedTransaction.status && (
                    <div
                      className={`flex items-center gap-2 ${
                        selectedTransaction.status === "successful"
                          ? "bg-green-50"
                          : selectedTransaction.status === "pending"
                          ? "bg-yellow-50"
                          : "bg-red-50"
                      } px-3 py-1 rounded-full`}
                    >
                      <div
                        className={`w-2 h-2 rounded-full ${
                          selectedTransaction.status === "successful"
                            ? "bg-green-500"
                            : selectedTransaction.status === "pending"
                            ? "bg-yellow-500"
                            : "bg-red-500"
                        }`}
                      />
                      <span
                        className={`text-sm ${
                          selectedTransaction.status === "successful"
                            ? "text-green-500"
                            : selectedTransaction.status === "pending"
                            ? "text-yellow-500"
                            : "text-red-500"
                        }`}
                      >
                        {selectedTransaction.status &&
                          selectedTransaction.status.charAt(0).toUpperCase() +
                            selectedTransaction.status.slice(1).toLowerCase()}
                      </span>
                    </div>
                  )}
                </span>
              </div> */}
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Timestamp</span>
                <div className="flex flex-col text-right">
                  <span className="font-bold text-sm">
                    {detailedFormat.date}
                  </span>
                  <span className="text-xs font-medium text-gray-500">
                    {detailedFormat.time}
                  </span>
                </div>
              </div>
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Transaction ID</span>
                <span className="text-sm font-bold text-gray-800">
                  {selectedTransaction?._id}
                </span>
              </div>

              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700 flex items-center gap-1">
                  Service Charge
                  <Info size={14} className="text-rose-500" />
                </span>

                <span className="text-sm font-bold text-gray-800">
                  {formatter.format(
                    // selectedTransaction?.fee,
                    0,
                    asset?.toUpperCase()
                  )}
                </span>
              </div>

              <div className="p-4 flex justify-between">
                <span className="text-sm font-bold text-gray-700">
                  Total Cost
                </span>
                <span className="text-sm font-bold text-gray-800">
                  {formatter.format(
                    selectedTransaction?.totalAmount,
                    asset?.toUpperCase()
                  )}
                </span>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default InvestTransactionHistorySingle;
